(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    

  if (!customElements.get('mi-header-clearance')) {
    customElements.define('mi-header-clearance', class extends HTMLElement {
      connectedCallback() {
        this._start = () => this.init();
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', this._start, { once: true });
        } else {
          this.init();
        }
      }

      disconnectedCallback() {
        document.removeEventListener('DOMContentLoaded', this._start);
        this._events?.abort();
        this._resize?.disconnect();
        cancelAnimationFrame(this._frame);
        this._anchor?.remove();
        if (this._main?.dataset.miHeaderSpaceOwner === this.id) {
          delete this._main.dataset.miHeaderSpaceOwner;
          this._main.style.removeProperty('--mi-header-base-padding');
          this._main.style.removeProperty('--mi-header-content-space');
        }
        if (document.documentElement.dataset.miHeaderAutoSpace === this.id) {
          delete document.documentElement.dataset.miHeaderAutoSpace;
          document.documentElement.style.removeProperty('--mi-header-occupied');
        }
      }

      init() {
        if (this.dataset.enabled !== 'true' || this._events) return;
        const header = document.getElementById('header-component');
        const wrapper = header?.closest('.header-section');
        const main = document.getElementById('MainContent') || document.querySelector('main');
        if (!header || !wrapper || !main) return;
        this._main = main;
        this._events = new AbortController();
        const signal = this._events.signal;
        let outer = wrapper;
        while (outer.parentElement && outer.parentElement !== document.body &&
               !outer.parentElement.contains(main)) outer = outer.parentElement;

        // This zero-height marker stays in document flow, outside sticky/fixed
        // header groups. It prevents the content padding from growing on scroll.
        const anchor = document.createElement('div');
        anchor.setAttribute('aria-hidden', 'true');
        anchor.style.cssText = 'display:block;height:0;min-height:0;margin:0;padding:0;border:0;line-height:0;overflow:hidden;pointer-events:none';
        outer.before(anchor);
        this._anchor = anchor;
        this._space = 0;
        let firstContent;
        let beforeHeader = [];

        const measure = () => {
          this._frame = 0;
          if (!firstContent?.isConnected) return;
          const scroll = window.scrollY;
          const anchorTop = anchor.getBoundingClientRect().top + scroll;
          const headerRect = header.getBoundingClientRect();
          const headerHeight = headerRect.height;
          let prefix = 0;
          for (const section of beforeHeader) {
            const style = getComputedStyle(section);
            if (style.display === 'none' || style.position === 'fixed' || style.position === 'absolute') continue;
            prefix += section.offsetHeight + (parseFloat(style.marginBlockStart) || 0) + (parseFloat(style.marginBlockEnd) || 0);
          }
          const topInset = Math.max(0, parseFloat(getComputedStyle(wrapper).top) || 0);
          // A floating header's viewport edge already includes its top inset.
          // Adding preceding section heights again creates a second offset.
          let fixed = false;
          let absolute = false;
          let stickyAncestor = false;
          for (let node = header; node && node !== document.body; node = node.parentElement) {
            const style = getComputedStyle(node);
            if (style.display === 'contents' || style.display === 'none') continue;
            if (style.position === 'fixed') fixed = true;
            if (style.position === 'absolute') absolute = true;
            if (style.position === 'sticky') stickyAncestor = true;
          }
          const restingBottom = fixed
            ? headerRect.bottom
            : scroll <= 1 || (absolute && !stickyAncestor)
              ? headerRect.bottom + scroll
              : Math.max(anchorTop + prefix, topInset) + headerHeight;
          const naturalContentTop = firstContent.getBoundingClientRect().top + scroll - this._space;
          const contentPosition = getComputedStyle(firstContent).position;
          const missing = ['fixed', 'absolute'].includes(contentPosition)
            ? 0
            : Math.max(0, Math.round((restingBottom - naturalContentTop) * 64) / 64);
          if (missing !== this._space) {
            this._space = missing;
            main.style.setProperty('--mi-header-content-space', `${missing}px`);
            // Margin collapse can change when the first padding is introduced.
            schedule();
          }
          const occupied = Math.ceil(Math.max(topInset + headerHeight, 0)) + 8;
          const value = `${occupied}px`;
          if (document.documentElement.style.getPropertyValue('--mi-header-occupied') !== value) {
            document.documentElement.style.setProperty('--mi-header-occupied', value);
          }
        };
        const schedule = () => {
          if (!this._frame) this._frame = requestAnimationFrame(measure);
        };
        const refresh = () => {
          // Recover responsive/theme padding before adding only missing space.
          delete main.dataset.miHeaderSpaceOwner;
          const base = parseFloat(getComputedStyle(main).paddingBlockStart) || 0;
          main.style.setProperty('--mi-header-base-padding', `${base}px`);
          main.dataset.miHeaderSpaceOwner = this.id;
          document.documentElement.dataset.miHeaderAutoSpace = this.id;
          const visibleContent = (node) => {
            if (['SCRIPT', 'STYLE', 'LINK', 'META', 'NOSCRIPT', 'TEMPLATE'].includes(node.tagName)) return null;
            const style = getComputedStyle(node);
            if (style.display === 'none' || ['hidden', 'collapse'].includes(style.visibility)) return null;
            const box = node.getBoundingClientRect();
            if (box.width > 1 && box.height > 1) return node;
            // Empty/hidden section placeholders and display:contents wrappers
            // are not the hero's visible boundary.
            for (const child of node.children) {
              const visible = visibleContent(child);
              if (visible) return visible;
            }
            return null;
          };
          firstContent = [...main.children].map(visibleContent).find(Boolean);
          beforeHeader = [...outer.querySelectorAll('.shopify-section')].filter(section =>
            section !== wrapper && !section.contains(wrapper) &&
            (section.compareDocumentPosition(wrapper) & Node.DOCUMENT_POSITION_FOLLOWING) &&
            !section.parentElement?.closest('.shopify-section')
          );
          this._resize?.disconnect();
          this._resize = new ResizeObserver(schedule);
          this._resize.observe(header);
          if (firstContent) this._resize.observe(firstContent);
          for (const section of beforeHeader) this._resize.observe(section);
          schedule();
        };
        window.addEventListener('resize', refresh, { passive: true, signal });
        window.addEventListener('scroll', schedule, { passive: true, signal });
        document.addEventListener('shopify:section:load', refresh, { signal });
        document.addEventListener('shopify:section:reorder', refresh, { signal });
        document.addEventListener('shopify:section:unload', () => {
          requestAnimationFrame(() => { if (this.isConnected) refresh(); });
        }, { signal });
        refresh();
      }
    });
  }

  if (!customElements.get('mi-header-sale-announcement')) {
    customElements.define('mi-header-sale-announcement', class extends HTMLElement {
      connectedCallback() {
        // A deferred section bundle normally runs after parsing. Waiting also
        // supports HTML being streamed or inserted by the theme editor.
        this._start = () => this.init();
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', this._start, { once: true });
        } else {
          this.init();
        }
      }

      disconnectedCallback() {
        document.removeEventListener('DOMContentLoaded', this._start);
        this._events?.abort();
        clearInterval(this._interval);
        clearTimeout(this._copyTimeout);
        this._stackResize?.disconnect();
        cancelAnimationFrame(this._stackFrame);
        if (this._stackGroup?.dataset.miHeaderStack === this.id) {
          delete this._stackGroup.dataset.miHeaderStack;
        }
        this._stackWrapper?.style.removeProperty('--mi-header-sticky-top');
      }

      init() {
        this._events?.abort();
        clearInterval(this._interval);
        this._events = new AbortController();
        const signal = this._events.signal;
        this._live = this.querySelector('[data-live]');
        this._expired = this.querySelector('[data-expired]');
        this._countdown = this.querySelector('[data-countdown]');
        this._panel = this.querySelector('[data-panel]');
        this._signup = this.querySelector('[data-signup]');
        this._editor = this.dataset.editor === 'true';
        this.setupHeaderStack(signal);

        this.querySelector('[data-copy]')?.addEventListener('click', () => this.copyCode(), { signal });
        this._signup?.addEventListener('click', () => this.openSignup(this._panel.hidden), { signal });
        this._panel?.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') {
            this.openSignup(false);
            this._signup?.focus();
          }
        }, { signal });

        const value = this.dataset.end.trim();
        this._end = this.parseEnd(value);
        if (Number.isFinite(this._end)) {
          this.updateCountdown();
          if (this._end > Date.now()) {
            this._interval = setInterval(() => this.updateCountdown(), 1000);
            document.addEventListener('visibilitychange', () => {
              if (!document.hidden) this.updateCountdown();
            }, { signal });
          }
        } else {
          this._countdown.hidden = true;
          // A nonempty, invalid deadline never leaves an unchecked sale live.
          if (value) {
            if (!this._editor) this.hidden = true;
            this.editorNote('Invalid sale end. Use YYYY-MM-DDTHH:MM:SS with Z or an offset, such as -06:00.');
          } else {
            this.editorNote('Set Sale end date and time to display the countdown.');
          }
        }

        if (this.querySelector('[data-form-feedback]') && !this.hidden && !this._live.hidden) {
          this.openSignup(true, false);
        }
      }

      setupHeaderStack(signal) {
        const header = this.closest('#header-component[data-mi-sale-sticky]');
        const wrapper = header?.closest('.header-section');
        if (!wrapper) return;
        this._stackWrapper = wrapper;

        // A short grouping container prevents its child from remaining sticky
        // past that group's bottom. Horizon normally uses display: contents.
        // Apply that behavior to the actual header-only parent, not a guessed ID.
        const group = wrapper.parentElement;
        if (group && group !== document.body && !group.querySelector('main')) {
          this._stackGroup = group;
          group.dataset.miHeaderStack = this.id;
        }

        let pinned = [];
        const refresh = () => {
          pinned = [];
          for (const section of document.querySelectorAll('.shopify-section')) {
            if (section === wrapper || section.contains(wrapper) ||
                !(section.compareDocumentPosition(wrapper) & Node.DOCUMENT_POSITION_FOLLOWING)) continue;
            for (const node of [section, ...section.querySelectorAll('*')]) {
              const style = getComputedStyle(node);
              if (style.position === 'fixed' || style.position === 'sticky') pinned.push(node);
            }
          }
          schedule();
        };
        const measure = () => {
          this._stackFrame = 0;
          let top = 0;
          const width = wrapper.getBoundingClientRect().width;
          // Respect a preceding pinned status strip, while ignoring floating
          // buttons and badges that don't span most of the header.
          const rects = pinned.map(node => node.getBoundingClientRect())
            .filter(rect => rect.width >= width * .5 && rect.height > 0)
            .sort((a, b) => a.top - b.top);
          for (const rect of rects) {
            if (rect.top <= top + 1 && rect.bottom > top) top = rect.bottom;
          }
          const value = `${Math.max(0, Math.ceil(top))}px`;
          if (wrapper.style.getPropertyValue('--mi-header-sticky-top') !== value) {
            wrapper.style.setProperty('--mi-header-sticky-top', value);
          }
        };
        const schedule = () => {
          if (!this._stackFrame) this._stackFrame = requestAnimationFrame(measure);
        };
        window.addEventListener('scroll', schedule, { passive: true, signal });
        window.addEventListener('resize', refresh, { passive: true, signal });
        document.addEventListener('shopify:section:load', refresh, { signal });
        document.addEventListener('shopify:section:unload', refresh, { signal });
        document.addEventListener('shopify:section:reorder', refresh, { signal });
        this._stackResize?.disconnect();
        this._stackResize = new ResizeObserver(schedule);
        this._stackResize.observe(header);
        refresh();
      }

      parseEnd(value) {
        // Require an explicit time zone so every visitor sees the same deadline.
        const match = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})(Z|[+-]\d{2}:\d{2})$/.exec(value);
        if (!match) return NaN;
        const [, year, month, day, hour, minute, second, offset] = match;
        const local = new Date(Date.UTC(+year, +month - 1, +day, +hour, +minute, +second));
        if (local.getUTCFullYear() !== +year || local.getUTCMonth() !== +month - 1 ||
            local.getUTCDate() !== +day || local.getUTCHours() !== +hour ||
            local.getUTCMinutes() !== +minute || local.getUTCSeconds() !== +second) return NaN;
        if (offset !== 'Z' && (+offset.slice(1, 3) > 14 || +offset.slice(4) > 59 ||
            (+offset.slice(1, 3) === 14 && +offset.slice(4) !== 0))) return NaN;
        return Date.parse(value);
      }

      updateCountdown() {
        const remaining = this._end - Date.now();
        if (remaining <= 0) {
          clearInterval(this._interval);
          this._live.hidden = true;
          this._countdown.hidden = true;
          this.openSignup(false);
          if (this.dataset.expiry === 'hide' && !this._editor) {
            this.hidden = true;
          } else {
            this._expired.hidden = false;
          }
          this.editorNote('This sale has ended. Storefront behavior follows When the sale ends.');
          return;
        }

        const secondsVisible = this.dataset.seconds === 'true';
        // Without seconds, round up to the next minute until the actual end.
        const total = secondsVisible ? Math.ceil(remaining / 1000) : Math.ceil(remaining / 60000) * 60;
        const values = {
          days: Math.floor(total / 86400),
          hours: Math.floor(total % 86400 / 3600),
          minutes: Math.floor(total % 3600 / 60),
          seconds: total % 60
        };
        for (const [key, number] of Object.entries(values)) {
          const node = this.querySelector(`[data-${key}]`);
          if (node) {
            const text = String(number).padStart(2, '0');
            if (node.textContent !== text) node.textContent = text;
          }
        }
        this._countdown.hidden = false;
        this._live.hidden = false;
        this._expired.hidden = true;
        this.hidden = false;
      }

      openSignup(open, focus = true) {
        if (!this._panel || !this._signup) return;
        this._panel.hidden = !open;
        this._signup.setAttribute('aria-expanded', String(open));
        if (open && focus) this._panel.querySelector('input[type="email"]')?.focus();
      }

      async copyCode() {
        const button = this.querySelector('[data-copy]');
        const status = this.querySelector('[data-copy-status]');
        clearTimeout(this._copyTimeout);
        try {
          await navigator.clipboard.writeText(button.dataset.code);
          if (!this.isConnected) return;
          button.setAttribute('aria-label', this.dataset.copiedLabel);
          button.dataset.copied = 'true';
          button.title = this.dataset.copiedLabel;
          status.textContent = this.dataset.copiedLabel;
          // Keep the actual discount code visible and avoid layout movement.
          this._copyTimeout = setTimeout(() => {
            button.setAttribute('aria-label', `${this.dataset.copyLabel}: ${button.dataset.code}`);
            button.removeAttribute('title');
            delete button.dataset.copied;
            status.textContent = '';
          }, 2500);
        } catch {
          if (!this.isConnected) return;
          const range = document.createRange();
          range.selectNodeContents(button.querySelector('[data-code-text]'));
          const selection = window.getSelection();
          selection?.removeAllRanges();
          selection?.addRange(range);
          status.textContent = this.dataset.copyFailed;
        }
      }

      editorNote(message) {
        const note = this.querySelector('[data-editor-note]');
        if (note) {
          note.textContent = message;
          note.hidden = false;
        }
      }
    });
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mi-announcement-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mi-sale-announcement')) {
    customElements.define('mi-sale-announcement', class extends HTMLElement {
      connectedCallback() {
        // A deferred section bundle normally runs after parsing. Waiting also
        // supports HTML being streamed or inserted by the theme editor.
        this._start = () => this.init();
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', this._start, { once: true });
        } else {
          this.init();
        }
      }

      disconnectedCallback() {
        document.removeEventListener('DOMContentLoaded', this._start);
        this._events?.abort();
        clearInterval(this._interval);
        clearTimeout(this._copyTimeout);
      }

      init() {
        this._events?.abort();
        clearInterval(this._interval);
        this._events = new AbortController();
        const signal = this._events.signal;
        this._live = this.querySelector('[data-live]');
        this._expired = this.querySelector('[data-expired]');
        this._countdown = this.querySelector('[data-countdown]');
        this._panel = this.querySelector('[data-panel]');
        this._signup = this.querySelector('[data-signup]');
        this._editor = this.dataset.editor === 'true';

        this.querySelector('[data-copy]')?.addEventListener('click', () => this.copyCode(), { signal });
        this._signup?.addEventListener('click', () => this.openSignup(this._panel.hidden), { signal });
        this._panel?.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') {
            this.openSignup(false);
            this._signup?.focus();
          }
        }, { signal });

        const value = this.dataset.end.trim();
        this._end = this.parseEnd(value);
        if (Number.isFinite(this._end)) {
          this.updateCountdown();
          if (this._end > Date.now()) {
            this._interval = setInterval(() => this.updateCountdown(), 1000);
            document.addEventListener('visibilitychange', () => {
              if (!document.hidden) this.updateCountdown();
            }, { signal });
          }
        } else {
          this._countdown.hidden = true;
          // A nonempty, invalid deadline never leaves an unchecked sale live.
          if (value) {
            if (!this._editor) this.hidden = true;
            this.editorNote('Invalid sale end. Use YYYY-MM-DDTHH:MM:SS with Z or an offset, such as -06:00.');
          } else {
            this.editorNote('Set Sale end date and time to display the countdown.');
          }
        }

        if (this.querySelector('[data-form-feedback]') && !this.hidden && !this._live.hidden) {
          this.openSignup(true, false);
        }
      }

      parseEnd(value) {
        // Require an explicit time zone so every visitor sees the same deadline.
        const match = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})(Z|[+-]\d{2}:\d{2})$/.exec(value);
        if (!match) return NaN;
        const [, year, month, day, hour, minute, second, offset] = match;
        const local = new Date(Date.UTC(+year, +month - 1, +day, +hour, +minute, +second));
        if (local.getUTCFullYear() !== +year || local.getUTCMonth() !== +month - 1 ||
            local.getUTCDate() !== +day || local.getUTCHours() !== +hour ||
            local.getUTCMinutes() !== +minute || local.getUTCSeconds() !== +second) return NaN;
        if (offset !== 'Z' && (+offset.slice(1, 3) > 14 || +offset.slice(4) > 59 ||
            (+offset.slice(1, 3) === 14 && +offset.slice(4) !== 0))) return NaN;
        return Date.parse(value);
      }

      updateCountdown() {
        const remaining = this._end - Date.now();
        if (remaining <= 0) {
          clearInterval(this._interval);
          this._live.hidden = true;
          this._countdown.hidden = true;
          this.openSignup(false);
          if (this.dataset.expiry === 'hide' && !this._editor) {
            this.hidden = true;
          } else {
            this._expired.hidden = false;
          }
          this.editorNote('This sale has ended. Storefront behavior follows When the sale ends.');
          return;
        }

        const secondsVisible = this.dataset.seconds === 'true';
        // Without seconds, round up to the next minute until the actual end.
        const total = secondsVisible ? Math.ceil(remaining / 1000) : Math.ceil(remaining / 60000) * 60;
        const values = {
          days: Math.floor(total / 86400),
          hours: Math.floor(total % 86400 / 3600),
          minutes: Math.floor(total % 3600 / 60),
          seconds: total % 60
        };
        for (const [key, number] of Object.entries(values)) {
          const node = this.querySelector(`[data-${key}]`);
          if (node) {
            const text = String(number).padStart(2, '0');
            if (node.textContent !== text) node.textContent = text;
          }
        }
        this._countdown.hidden = false;
        this._live.hidden = false;
        this._expired.hidden = true;
        this.hidden = false;
      }

      openSignup(open, focus = true) {
        if (!this._panel || !this._signup) return;
        this._panel.hidden = !open;
        this._signup.setAttribute('aria-expanded', String(open));
        if (open && focus) this._panel.querySelector('input[type="email"]')?.focus();
      }

      async copyCode() {
        const button = this.querySelector('[data-copy]');
        const status = this.querySelector('[data-copy-status]');
        clearTimeout(this._copyTimeout);
        try {
          await navigator.clipboard.writeText(button.dataset.code);
          if (!this.isConnected) return;
          button.setAttribute('aria-label', this.dataset.copiedLabel);
          button.dataset.copied = 'true';
          button.title = this.dataset.copiedLabel;
          status.textContent = this.dataset.copiedLabel;
          // Keep the actual discount code visible and avoid layout movement.
          this._copyTimeout = setTimeout(() => {
            button.setAttribute('aria-label', `${this.dataset.copyLabel}: ${button.dataset.code}`);
            button.removeAttribute('title');
            delete button.dataset.copied;
            status.textContent = '';
          }, 2500);
        } catch {
          if (!this.isConnected) return;
          const range = document.createRange();
          range.selectNodeContents(button.querySelector('[data-code-text]'));
          const selection = window.getSelection();
          selection?.removeAllRanges();
          selection?.addRange(range);
          status.textContent = this.dataset.copyFailed;
        }
      }

      editorNote(message) {
        const note = this.querySelector('[data-editor-note]');
        if (note) {
          note.textContent = message;
          note.hidden = false;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
